import React from "react";
import BaseIcon from "../../../../../components/svg_icons/BaseIcon";

const offices = [
    {
        name: "Ahmedabad",
        employees: 55,
        online: 47,
        activeTasks: 32,
        productivity: 92,
        color: "#2563eb",
    },
    {
        name: "Surat",
        employees: 38,
        online: 31,
        activeTasks: 21,
        productivity: 88,
        color: "#10b981",
    },
    {
        name: "Mumbai",
        employees: 35,
        online: 28,
        activeTasks: 19,
        productivity: 85,
        color: "#f59e0b",
    },
];

const OfficeOverview = () => {
    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "24px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                }}
            >
                <div>
                    <h2
                        style={{
                            margin: 0,
                            color: "#0f172a",
                        }}
                    >
                        Offices
                    </h2>

                    <p
                        style={{
                            marginTop: "6px",
                            color: "#64748b",
                            fontSize: "14px",
                        }}
                    >
                        Office-wise performance overview.
                    </p>
                </div>

                <button
                    style={{
                        padding: "8px 14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "10px",
                        background: "#fff",
                        cursor: "pointer",
                    }}
                >
                    View All
                </button>
            </div>

            {offices.map((office) => (
                <div
                    key={office.name}
                    style={{
                        border: "1px solid #e5e7eb",
                        borderLeft: `5px solid ${office.color}`,
                        borderRadius: "12px",
                        padding: "18px",
                        marginBottom: "16px",
                        cursor: "pointer",
                        transition: "0.2s",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#fff";
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "14px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                            }}
                        >
                            <div
                                style={{
                                    width: "44px",
                                    height: "44px",
                                    borderRadius: "12px",
                                    background: `${office.color}20`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: office.color,
                                }}
                            >
                                <BaseIcon name="building" />
                            </div>

                            <div>
                                <strong>{office.name}</strong>

                                <div
                                    style={{
                                        color: "#64748b",
                                        fontSize: "13px",
                                    }}
                                >
                                    {office.employees} Employees
                                </div>
                            </div>
                        </div>

                        <strong style={{ color: office.color }}>
                            {office.productivity}%
                        </strong>
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3,1fr)",
                            gap: "12px",
                            marginBottom: "14px",
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#64748b",
                                }}
                            >
                                Online
                            </div>

                            <strong>{office.online}</strong>
                        </div>

                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#64748b",
                                }}
                            >
                                Active Tasks
                            </div>

                            <strong>{office.activeTasks}</strong>
                        </div>

                        <div>
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#64748b",
                                }}
                            >
                                Productivity
                            </div>

                            <strong>{office.productivity}%</strong>
                        </div>
                    </div>

                    <div
                        style={{
                            height: "8px",
                            background: "#e5e7eb",
                            borderRadius: "999px",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                width: `${office.productivity}%`,
                                height: "100%",
                                background: office.color,
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default OfficeOverview;
